import React from 'react'
import styles from './SeekStyles'

export default ({ onChange, percentagePlayed, percentageBuffered, className, ariaLabel }) => {
  const widthBuffer = `${percentageBuffered || 0}%`
  const widthPlayed = `${percentagePlayed || 0}%`
  return (
    <div className={styles.component}>
      <div className={styles.track}>
        <div
          className={styles.buffer}
          style={{
            width: widthBuffer
          }} />
        <div
          className={styles.fill}
          style={{
            width: widthPlayed
          }} />
        <input
          min='0'
          step={1}
          max='100'
          type='range'
          orient='horizontal'
          onChange={onChange}
          aria-label={ariaLabel}
          className={styles.input}
          value={percentagePlayed || 0} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Seek/Seek.js